<app-modal-pesquisa-lista
  [aberta]="aberta"
  titulo="Pesquisar empregador"
  [termo]="termo"
  nomeCampo="buscaEmpregadorModal"
  placeholder="Digite razao social, fantasia ou CNPJ"
  mensagemVazia="Digite ao menos 3 caracteres para pesquisar."
  [itens]="empregadores"
  [rotuloItem]="rotuloEmpregador"
  [detalheItem]="detalheEmpregador"
  (termoChange)="termoChange.emit($event)"
  (selecionar)="selecionarEmpregador($event)"
  (limpar)="limpar.emit()"
  (fechar)="fechar.emit()">
</app-modal-pesquisa-lista>
